import { useEffect } from "react";

import { useUser } from "libs/auth";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import storage from "utils/storage";

import { ProtectedRoutes } from "./protected";
import { PublicRoutes } from "./public";

export const AppRoutes = () => {
  const { data: user, isLoading } = useUser();

  useEffect(() => {
    if (!isLoading)
      if (user && !storage.getRebuildOnce()) {
        window.location.reload();
        storage.setRebuildOnce(true);
      }
  }, [user, isLoading]);
  useEffect(() => {
    if (!user) storage.setRebuildOnce(false);
  }, [user]);

  const CommonRoutes: RouteObject[] = [
    { path: "*", element: <Navigate to="/authentication/sign-in" /> },
  ];

  const routes = user ? ProtectedRoutes : PublicRoutes;

  const element = useRoutes([...routes, ...CommonRoutes]);

  return element;
};
